module.exports = __webpack_public_path__ + "@/assets/img/017-girl-8.3d6a53cd.svg";